import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProjectOutput } from 'core/http/dev';
import { apiUrl } from 'core/http/lg-logistic-rest-api/api/api.service';
import { ProjectSchedule, Withdrawn } from 'core/http/root';
import { Observable } from 'rxjs';
import { Uuid } from 'shared/common/types';

export interface UpdateCurrentProjectInput {
  currencyCode: string;
  defaultStatusId: Uuid | null;
  defaultStorehouseId: Uuid | null;
  withdrawnType: Withdrawn;
  withdrawnSchedules: ProjectSchedule;
}

@Injectable()
export class CurrentProjectService {
  constructor(private http: HttpClient) {}

  getCurrentProject(): Observable<ProjectOutput> {
    return this.http.get<ProjectOutput>(apiUrl(`/project/current`));
  }

  updateCurrentProject(input: UpdateCurrentProjectInput): Observable<ProjectOutput> {
    return this.http.put<ProjectOutput>(apiUrl(`/project/current`), input);
  }
}
